import React, { useState } from 'react';
import { NavLink } from 'react-router-dom';
import { useCart } from '../context/CartContext';

function CartIcon() {
  return (
    <svg width="22" height="22" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M3 3h2l.4 2M7 13h10l4-8H5.4M7 13L5.4 5M7 13l-2.293 2.293A1 1 0 0 0 5.414 17H17M17 17a2 2 0 1 0 0 4 2 2 0 0 0 0-4ZM9 21a2 2 0 1 0 0-4 2 2 0 0 0 0 4Z"
        stroke="currentColor"
        strokeWidth="1.8"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export default function Navbar() {
  const { totalItems } = useCart();
  const [menuOpen, setMenuOpen] = useState(false);
  const linkClass = ({ isActive }) => (isActive ? 'active-link' : '');
  const closeMenu = () => setMenuOpen(false);

  return (
    <nav className="navbar">
      <div className="nav-container">
        <div className="brand-logo">
          <NavLink to="/" style={{ textDecoration: 'none' }} onClick={closeMenu}>
            <span className="brand-glow">3D FILA SPACE</span>
          </NavLink>
        </div>

        {/* Desktop */}
        <div className="nav-links">
          <NavLink to="/products" className={linkClass}>Products</NavLink>
          <NavLink to="/about" className={linkClass}>About Us</NavLink>
          <NavLink to="/cart" className="cart-link">
            <CartIcon />
            {totalItems > 0 && <span className="cart-count">{totalItems}</span>}
          </NavLink>
          <div className="nav-buttons">
            <NavLink to="/login" className="cta-button-nav">Login</NavLink>
            <NavLink to="/signup" className="cta-button-signup">Sign Up</NavLink>
          </div>
        </div>

        {/* Mobile-only */}
        <div className="nav-mobile-controls">
          <NavLink to="/cart" className="cart-link" onClick={closeMenu}>
            <CartIcon />
            {totalItems > 0 && <span className="cart-count">{totalItems}</span>}
          </NavLink>
          <button
            className={`hamburger ${menuOpen ? 'open' : ''}`}
            onClick={() => setMenuOpen((prev) => !prev)}
            aria-label="Toggle menu"
            aria-expanded={menuOpen}
          >
            {!menuOpen ? (
              <svg className="menu-icon" width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M3 6h18M3 12h18M3 18h18" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
              </svg>
            ) : (
              <svg className="close-icon" width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M6 6l12 12M6 18L18 6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
              </svg>
            )}
          </button>
        </div>
      </div>

      <div className={`mobile-menu ${menuOpen ? 'open' : ''}`}>
        <NavLink to="/products" className={linkClass} onClick={closeMenu}>Products</NavLink>
        <NavLink to="/about" className={linkClass} onClick={closeMenu}>About Us</NavLink>
        <NavLink to="/login" className="cta-button-nav" onClick={closeMenu}>Login</NavLink>
        <NavLink to="/signup" className="cta-button-signup" onClick={closeMenu}>Sign Up</NavLink>
      </div>
    </nav>
  );
}